<template>
  <b-container fluid>
    <b-row>
      <b-col lg="6" offset-lg="4"><span><h2>Sent Alerts</h2></span></b-col>
    </b-row>
    <vue-good-table
        :columns="columns"
        :rows="rows"
        :groupOptions="{
                 enabled: false,
                headerPosition: 'top'
                }"
        :sort-options="{
                    enabled: true,
                    collapsable: true
                }"
        :defaultSortBy="{field: 'status', type: 'certificationDate'}"
        styleClass="vgt-table condensed table-bordered table-striped"
        :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 50,
                    position: 'top',
                    perPageDropdown: [50, 100, 200],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                }">
      <!--@on-row-click="onRowClick"-->
      <template slot="table-row" slot-scope="props">
                <span v-if="props.column.label === 'View'">
                    <b-button size="sm"
                              @click="goToAccountRequest(props.formattedRow[props.column.field],
                              props.formattedRow['entityType'])">
                            View
                </b-button>
                </span>
        <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                </span>
      </template>
    </vue-good-table>
  </b-container>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';

export default {
  name: "AccountRequestList",
  components: {
    VueGoodTable
  },
  data() {
    return {
      requests: [],
      columns: [
        {
          label: "Group Id",
          field: "groupId"
        },
        {
          label: "Group Name",
          field: "groupName",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Name', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "Result",
          field: "result"
        },
        {
          label: "Alert Type",
          field: "type",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Type', // placeholder for filter input
            //filterValue: 'PENDING', // initial populated value for this filter
            /*filterDropdownItems: [{value: 'APPROVED', text: 'APPROVED'},
              {value: 'DENIED', text: 'DENIED'},
              {value: 'PENDING', text: 'PENDING'}]*/
          }
        },
        {
          label: "SubType",
          field: "subType"
        },
        {
          label: "Sent Date",
          field: "alertDate",
          type: 'date',
          dateInputFormat: 'T',
          dateOutputFormat: 'MMM dd yy',
        },
        {
          label: "Recipient",
          field: "recipient"
        },
        {
          label: "Recipient Email",
          field: "recipientEmail"
        }],
      rows: []
    }
  },
  mounted() {
    this.$http.get("admin/alerts/sent")
        .then(result => {
          this.requests = result.data;
          this.rows = result.data;
        })
        .catch(error => {
          console.log("Couldn't Retrieve Requests", error);
        })
  },
  methods: {
    goToAccountRequest: function (id, entityType) {
      if (entityType === 'WINE') {
        //this.$router.push({name: 'Account Request Review', params: {requestId: id}})
      } else {
        //this.$router.push({name: 'Vineyard Account Request Review', params: {requestId: id}})
      }
    }
  }
}
</script>

<style scoped>

</style>
